import { Card, CardContent, Grid } from '@mui/material'
import DetailsImg from '@/assets/img/realtime/details.png'
import { TitleComponent } from '@/components/Basic/library'
import { StaticDatePickerLandscape } from './calendar.component'
import { SiteComponent } from './site.component'
import { useSite } from '../../useSite'
import { SiteTypes } from '@/types/siteTypes'
import { useTranslation } from 'react-i18next'

export const Tab1Component = ({
    autoSave,
    holidays,
    checkIn,
    checkOut,
    observationEndDate,
    weekendCheckOut,
    weekendCheckIn,
}) => {
    const { site } = useSite()
    const { t } = useTranslation('site', { keyPrefix: 'constraints.siteConfiguration' })
    return (
        <Grid container spacing={2} style={{ marginBottom: 40 }}>
            <Grid item md={12} sm={12} xs={12}>
                <SiteComponent
                    checkIn={checkIn}
                    checkOut={checkOut}
                    autoSave={autoSave}
                    observationEndDate={observationEndDate}
                    weekendCheckOut={weekendCheckOut}
                    weekendCheckIn={weekendCheckIn}
                />
            </Grid>

            {site?.siteType !== SiteTypes.HOTEL && (
                <Grid item md={12} sm={12} xs={12}>
                    <Card style={{ marginBottom: 40 }}>
                        <CardContent>
                            <div
                                style={{
                                    color: '#050C22',
                                    fontSize: 14,
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontWeight: 500,
                                }}
                            >
                                <img src={DetailsImg} style={{ marginRight: 10, maxHeight: 20 }} />
                                <TitleComponent title={t('holidays')} style={{ fontSize: 15 }} />
                            </div>
                            <StaticDatePickerLandscape
                                // setModified={setModified}
                                holidays={holidays}
                                setHolidays={(e) => {
                                    autoSave({ _holidays: e })
                                }}
                            />
                        </CardContent>
                    </Card>
                </Grid>
            )}
        </Grid>
    )
}
